import React from "react";
import { NavLink } from "react-router-dom";

// Abas de 2º nível, dentro da Listagem. Uma por rota de consumo do backend:
// cada uma faz UMA requisição, à sua própria rota, e tem estado próprio — falha
// numa não contamina a outra.
//
// `nav-pills` em vez de `nav-tabs` de propósito: dois níveis de aba com o mesmo
// visual fariam o usuário perder de vista qual é qual.
const SUB_TABS = [
  { to: "/calculator-api", label: "Cálculos", exact: true },
  // rota em inglês de propósito: `/calculator-api/consultas` acendia junto o
  // item `/consultas` do menu lateral, que casa por substring da URL
  { to: "/calculator-api/queries", label: "Consultas" },
];

export default function UsageSubTabs() {
  return (
    <ul className="nav nav-pills nav-pills-sm mb-5">
      {SUB_TABS.map(tab => (
        <li className="nav-item mr-2" key={tab.to}>
          <NavLink
            className="nav-link py-2 px-4"
            activeClassName="active"
            exact={tab.exact}
            to={tab.to}
          >
            {tab.label}
          </NavLink>
        </li>
      ))}
    </ul>
  );
}
